exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".link[data-v-d4547502]:hover {\n  cursor: pointer;\n}\n", "", {"version":3,"sources":["/var/www/zp_frontend_vuejs/src/views/Modals/LogoutConfirmationModal.vue"],"names":[],"mappings":"AAqCA;EAEI,gBAAe;CAAA","file":"LogoutConfirmationModal.vue?vue&type=style&index=0&id=d4547502&lang=scss&scoped=true&","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.link {\n  &:hover {\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);

// exports
